/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Football(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M225.98,56.31055a32.13113,32.13113,0,0,0-26.29-26.29053c-31.35058-5.30908-90.43652-7.72363-133.915,35.75439-43.478,43.478-41.064,102.56446-35.75488,133.915a32.13113,32.13113,0,0,0,26.29,26.29053,200.74409,200.74409,0,0,0,33.27637,2.83984c31.082,0,69.78955-7.74511,100.63867-38.59423C233.70361,146.74756,231.28906,87.66113,225.98,56.31055Zm-166.998,153.894a16.11587,16.11587,0,0,1-13.18652-13.18652,184.687,184.687,0,0,1-2.68555-30.59473l46.48267,46.48291A185.002,185.002,0,0,1,58.98193,210.20459ZM165.65674,101.65674,150.6272,116.68652l8.97046,8.97022a8,8,0,0,1-11.31348,11.314L139.31372,128l-11.314,11.314,8.97045,8.97022a7.99983,7.99983,0,1,1-11.31347,11.31348l-8.97046-8.97022-15.02954,15.0293a7.99984,7.99984,0,0,1-11.31348-11.31348l15.02954-15.02978-8.97046-8.97022a8,8,0,0,1,11.31348-11.314L116.68628,128l11.314-11.314-8.97045-8.97022a7.99983,7.99983,0,1,1,11.31347-11.31348l8.97046,8.97022,15.02954-15.0293a7.99984,7.99984,0,0,1,11.31348,11.31348Zm.75024-58.563a185.0087,185.0087,0,0,1,30.61109,2.70166,16.11531,16.11531,0,0,1,13.18652,13.18652,184.687,184.687,0,0,1,2.68555,30.59473Z" />
    </Svg>
  );
}

export default Football;
